import { Component } from '@angular/core';

@Component({
  selector: 'app-e-service',
  imports: [],
  templateUrl: './e-service.component.html',
  styleUrl: './e-service.component.scss'
})
export class EServiceComponent {

}
